import { createContext, useContext } from 'react';

interface DemoPassContextValue {
  isDemoPass: boolean;
  setIsDemoPass: (value: boolean) => void;
}

export const DemoPassContext = createContext<DemoPassContextValue>({
  isDemoPass: false,
  setIsDemoPass: () => undefined,
});

export const useDemoPass = () => useContext(DemoPassContext);
